import { MANAGEMENT_SIGNALS_API_INTEGRATION_SUBSCRIBED_DOMAINS_URL } from "./const";
import type { ManagementSubscribeDomainsIntegrationQueryFactory } from "./types";

export const managementSubscribeDomainsQueryKeys: ManagementSubscribeDomainsIntegrationQueryFactory = {
    getUrl(): readonly string[] {
        return [MANAGEMENT_SIGNALS_API_INTEGRATION_SUBSCRIBED_DOMAINS_URL];
    },
};
